// Reconciles a <textarea>'s value with an externally-supplied target string
// while preserving the caret position. Used by TextEditor so the Yjs round-trip
// after a local keystroke doesn't snap the caret back to the end of the string.
//
// Behavior:
//   - If the textarea already shows `target`, do nothing. This is the
//     common case: the user just typed and the Yjs observer is firing
//     with the same text the user committed.
//   - If `target` diverges (a peer wrote, or external state changed),
//     overwrite the value but keep the local caret at the same offset,
//     clamped to the new text length.

export function syncTextareaValue(el: HTMLTextAreaElement, target: string): void {
  if (el.value === target) return;
  const start = el.selectionStart ?? target.length;
  const end = el.selectionEnd ?? target.length;
  el.value = target;
  const clampedStart = Math.min(start, target.length);
  const clampedEnd = Math.min(end, target.length);
  el.setSelectionRange(clampedStart, clampedEnd);
}
